<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-actions">
    <div class="giga-actions_left">
      <ul class="giga-actions_row">
        <li class="giga-action_item">
          <div class="giga-action_search">
            <input
              type="text"
              placeholder="Recherche"
              v-model="search"
              @input="onSearch()"
            />
            <button class="giga-search_button">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.7448 22.6899L17.772 16.7171C21.2724 12.4326 20.6421 6.12211 16.3576 2.62172C12.0768 -0.878671 5.76261 -0.248376 2.26222 4.03613C-1.23817 8.32064 -0.607873 14.6311 3.67663 18.1315C7.36461 21.1479 12.6696 21.1479 16.3576 18.1315L22.3304 24.1043C22.7431 24.472 23.3771 24.4382 23.7448 24.0255C24.0862 23.6466 24.0862 23.0726 23.7448 22.6899ZM10.0321 18.3941C5.60879 18.3941 2.02586 14.8149 2.02211 10.3916C2.02211 5.96829 5.60129 2.38536 10.0246 2.38161C14.4479 2.38161 18.0309 5.96078 18.0346 10.3841C18.0346 10.3841 18.0346 10.3879 18.0346 10.3916C18.0271 14.8074 14.4479 18.3866 10.0321 18.3941Z"
                  fill="#8C9DAB"
                />
              </svg>
            </button>
          </div>
        </li>

        <filter-modal
          v-if="!teamQuery && !agenceQuery && !operationQuery"
          :query-config="queryConfig"
          v-on:onFilter="onFilter($event)"
          v-on:onReloadData="reloadData($event)"
          :headerTitle="
            isSimulationContext ? 'filtrer_simulation' : 'filtrer_work'
          "
        ></filter-modal>

        <filter-modal
          v-if="teamQuery"
          :query-config="queryConfig"
          v-on:onFilter="usersFilter($event)"
          v-on:onReloadData="usersFilter($event)"
          headerTitle="filtrer_users"
        ></filter-modal>

        <filter-modal
          v-if="agenceQuery"
          :query-config="queryConfig"
          v-on:onFilter="AgencesFilter($event)"
          v-on:onReloadData="AgencesFilter($event)"
          headerTitle="filtrer_agences"
        ></filter-modal>

        <filter-modal
          v-if="operationQuery"
          :query-config="queryConfig"
          v-on:onFilter="OperationsFilter($event)"
          v-on:onReloadData="OperationsFilter($event)"
          headerTitle="filtrer_operations"
        ></filter-modal>
        <li class="giga-action_item" v-if="operationQuery">
          <div class="giga-button">
            <b-button
              variant="none"
              :class="[
                'giga-darkblue_outlined_button',
                'with-icon',
                { active: isSimulation }
              ]"
              @click="onEntityTypeClick(EntityType.SIMULATION)"
            >
              <i class="giga-icon">
                <svg
                  v-if="isSimulation"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4C1 2.34315 2.34315 1 4 1H17C18.6569 1 20 2.34315 20 4V17C20 18.6569 18.6569 20 17 20H4C2.34315 20 1 18.6569 1 17V4Z"
                    fill="white"
                  />
                  <path
                    d="M1 4C1 2.34315 2.34315 1 4 1H17C18.6569 1 20 2.34315 20 4V17C20 18.6569 18.6569 20 17 20H4C2.34315 20 1 18.6569 1 17V4Z"
                    fill="#132D48"
                  />
                  <path
                    d="M6.64286 9.64286L9.5 12.5L12 10L14.5 7.5M4 20H17C18.6569 20 20 18.6569 20 17V4C20 2.34315 18.6569 1 17 1H4C2.34315 1 1 2.34315 1 4V17C1 18.6569 2.34315 20 4 20Z"
                    stroke="#132D48"
                    stroke-width="2"
                  />
                  <path
                    d="M6.64286 9.64286L9.5 12.5L12 10L14.5 7.5M4 20H17C18.6569 20 20 18.6569 20 17V4C20 2.34315 18.6569 1 17 1H4C2.34315 1 1 2.34315 1 4V17C1 18.6569 2.34315 20 4 20Z"
                    stroke="white"
                    stroke-width="2"
                  />
                </svg>
                <svg
                  v-else
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="17"
                    height="17"
                    rx="2"
                    stroke="#132D48"
                    stroke-width="2"
                    fill="white"
                  />
                </svg>
              </i>
              <span>{{ $t("simulations") }}</span>
            </b-button>
          </div>
        </li>

        <li class="giga-action_item" v-if="operationQuery">
          <div class="giga-button">
            <b-button
              variant="none"
              :class="[
                'giga-darkblue_outlined_button',
                'with-icon',
                { active: isOuvrage }
              ]"
              @click="onEntityTypeClick(EntityType.PROJECT)"
            >
              <i class="giga-icon">
                <svg
                  v-if="isOuvrage"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4C1 2.34315 2.34315 1 4 1H17C18.6569 1 20 2.34315 20 4V17C20 18.6569 18.6569 20 17 20H4C2.34315 20 1 18.6569 1 17V4Z"
                    fill="white"
                  />
                  <path
                    d="M1 4C1 2.34315 2.34315 1 4 1H17C18.6569 1 20 2.34315 20 4V17C20 18.6569 18.6569 20 17 20H4C2.34315 20 1 18.6569 1 17V4Z"
                    fill="#132D48"
                  />
                  <path
                    d="M6.64286 9.64286L9.5 12.5L12 10L14.5 7.5M4 20H17C18.6569 20 20 18.6569 20 17V4C20 2.34315 18.6569 1 17 1H4C2.34315 1 1 2.34315 1 4V17C1 18.6569 2.34315 20 4 20Z"
                    stroke="#132D48"
                    stroke-width="2"
                  />
                  <path
                    d="M6.64286 9.64286L9.5 12.5L12 10L14.5 7.5M4 20H17C18.6569 20 20 18.6569 20 17V4C20 2.34315 18.6569 1 17 1H4C2.34315 1 1 2.34315 1 4V17C1 18.6569 2.34315 20 4 20Z"
                    stroke="white"
                    stroke-width="2"
                  />
                </svg>
                <svg
                  v-else
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="1"
                    y="1"
                    width="17"
                    height="17"
                    rx="2"
                    stroke="#132D48"
                    stroke-width="2"
                    fill="white"
                  />
                </svg>
              </i>
              <span>{{ $t("works") }}</span>
            </b-button>
          </div>
        </li>
      </ul>
    </div>
    <div class="giga-actions_right">
      <ul class="giga-actions_row">
        <!-- ADD NEW AGENCE -->
        <li class="giga-action_item" v-if="agenceQuery">
          <div class="giga-button">
            <b-button class="giga-green_button with-icon" @click="newAgence()">
              <i class="giga-icon">
                <svg
                  class="fill"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM16.8 13.2H13.2V16.8C13.2 17.46 12.66 18 12 18C11.34 18 10.8 17.46 10.8 16.8V13.2H7.2C6.54 13.2 6 12.66 6 12C6 11.34 6.54 10.8 7.2 10.8H10.8V7.2C10.8 6.54 11.34 6 12 6C12.66 6 13.2 6.54 13.2 7.2V10.8H16.8C17.46 10.8 18 11.34 18 12C18 12.66 17.46 13.2 16.8 13.2Z"
                    fill="white"
                  />
                </svg>
              </i>
              <span>Ajouter une agence</span>
            </b-button>
          </div>
        </li>

        <!-- ADD NEW USER -->
        <li class="giga-action_item" v-if="teamQuery">
          <div class="giga-button">
            <b-button
              id="btn-add-user"
              class="giga-green_button with-icon"
              @click="newUser()"
            >
              <i class="giga-icon">
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 8C16.21 8 18 6.21 18 4C18 1.79 16.21 0 14 0C11.79 0 10 1.79 10 4C10 6.21 11.79 8 14 8ZM5 6V4C5 3.45 4.55 3 4 3C3.45 3 3 3.45 3 4V6H1C0.45 6 0 6.45 0 7C0 7.55 0.45 8 1 8H3V10C3 10.55 3.45 11 4 11C4.55 11 5 10.55 5 10V8H7C7.55 8 8 7.55 8 7C8 6.45 7.55 6 7 6H5ZM14 10C11.33 10 6 11.34 6 14V15C6 15.55 6.45 16 7 16H21C21.55 16 22 15.55 22 15V14C22 11.34 16.67 10 14 10Z"
                    fill="white"
                  />
                </svg>
              </i>
              <span>Ajouter un membre</span>
            </b-button>
          </div>
        </li>

        <!-- EDIT ROLES -->
        <li class="giga-action_item" v-if="false">
          <div class="giga-button">
            <b-button
              class="giga-blue_button with-icon"
              :to="{ name: 'Roles' }"
            >
              <i class="giga-icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 12.8538V15.5556C0 15.8045 0.195528 16 0.444383 16H3.14623C3.26177 16 3.37731 15.9556 3.4573 15.8667L13.1626 6.17025L9.82975 2.83738L0.133315 12.5338C0.0444383 12.6227 0 12.7293 0 12.8538ZM15.74 3.59283C16.0867 3.24622 16.0867 2.68629 15.74 2.33968L13.6603 0.259964C13.3137 -0.0866546 12.7538 -0.0866546 12.4072 0.259964L10.7807 1.8864L14.1136 5.21928L15.74 3.59283Z"
                    fill="white"
                  />
                </svg>
              </i>
              <span>Modifier les rôles</span>
            </b-button>
          </div>
        </li>

        <!-- ADD NEW SIMULATION -->
        <li
          class="giga-action_item"
          v-if="isSimulationContext && canCreateSimulation"
        >
          <div class="giga-button">
            <b-button
              id="btn-add-sim"
              class="giga-green_button with-icon"
              :to="{ name: 'AddSimulation' }"
            >
              <i class="giga-icon" v-if="!downloadLoader">
                <svg
                  class="fill"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM16.8 13.2H13.2V16.8C13.2 17.46 12.66 18 12 18C11.34 18 10.8 17.46 10.8 16.8V13.2H7.2C6.54 13.2 6 12.66 6 12C6 11.34 6.54 10.8 7.2 10.8H10.8V7.2C10.8 6.54 11.34 6 12 6C12.66 6 13.2 6.54 13.2 7.2V10.8H16.8C17.46 10.8 18 11.34 18 12C18 12.66 17.46 13.2 16.8 13.2Z"
                    fill="white"
                  />
                </svg>
              </i>
              <span>{{ $t("add_simulation") }}</span>
            </b-button>
          </div>
        </li>

        <li v-if="!teamQuery && !agenceQuery" class="giga-action_item">
          <div class="giga-button">
            <button
              :class="[
                isSimulationContext && canCreateSimulation || operationQuery
                  ? 'only-icon giga-blue_button'
                  : 'with-icon giga-green_button'
              ]"
              @click="$emit('download')"
            >
              <i class="giga-icon">
                <b-spinner
                  v-if="downloadLoader"
                  variant="light"
                  small
                  class="spinner"
                ></b-spinner>
              </i>
              <i class="giga-icon" v-if="!downloadLoader">
                <svg
                  class="stroke"
                  width="20"
                  height="17"
                  viewBox="0 0 20 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.2386 10.7527V14.0036C18.2386 14.8999 17.3821 15.6267 16.3258 15.6267H2.91284C1.85648 15.6267 0.999969 14.8999 0.999969 14.0036V10.7527"
                    stroke="white"
                    stroke-width="1.69271"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.83139 6.68774L9.61642 10.7526L14.4072 6.68774"
                    stroke="white"
                    stroke-width="1.69271"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.61639 10.7528V1"
                    stroke="white"
                    stroke-width="1.69271"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </i>
              <span v-if="(isSimulationContext && canCreateSimulation)|| operationQuery"></span>
              <span v-else>Télécharger</span>
            </button>
          </div>
        </li>
        <!-- GRID AND LIST VIEWS -->
        <li
          v-if="!teamQuery && !agenceQuery && !operationQuery"
          class="giga-action_item list-views"
        >
          <div v-if="!disableview" class="giga-button">
            <button
              class="only-icon"
              :class="[{ 'giga-blue_button': view === 'grid' }]"
              @click="$emit('changeView', 'grid')"
            >
              <i class="giga-icon">
                <svg
                  class="fill"
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.35307 0.898926H2.25125C1.4375 0.898926 0.777832 1.5586 0.777832 2.37235V8.47417C0.777832 9.28791 1.4375 9.94759 2.25125 9.94759H8.35307C9.16682 9.94759 9.82649 9.28791 9.82649 8.47417V2.37235C9.82649 1.5586 9.16682 0.898926 8.35307 0.898926Z"
                    fill="white"
                  />
                  <path
                    d="M21.3044 0.898926H15.2025C14.3888 0.898926 13.7291 1.5586 13.7291 2.37235V8.47417C13.7291 9.28791 14.3888 9.94759 15.2025 9.94759H21.3044C22.1181 9.94759 22.7778 9.28791 22.7778 8.47417V2.37235C22.7778 1.5586 22.1181 0.898926 21.3044 0.898926Z"
                    fill="white"
                  />
                  <path
                    d="M8.35307 13.6968H2.25125C1.4375 13.6968 0.777832 14.3565 0.777832 15.1702V21.272C0.777832 22.0858 1.4375 22.7454 2.25125 22.7454H8.35307C9.16682 22.7454 9.82649 22.0858 9.82649 21.272V15.1702C9.82649 14.3565 9.16682 13.6968 8.35307 13.6968Z"
                    fill="white"
                  />
                  <path
                    d="M21.3044 13.6968H15.2025C14.3888 13.6968 13.7291 14.3565 13.7291 15.1702V21.272C13.7291 22.0858 14.3888 22.7454 15.2025 22.7454H21.3044C22.1181 22.7454 22.7778 22.0858 22.7778 21.272V15.1702C22.7778 14.3565 22.1181 13.6968 21.3044 13.6968Z"
                    fill="white"
                  />
                </svg>
              </i>
            </button>
          </div>
          <div v-if="!disableview" class="giga-button">
            <button
              class="only-icon"
              :class="[{ 'giga-blue_button': view === 'list' }]"
              @click="$emit('changeView', 'list')"
            >
              <i class="giga-icon">
                <svg
                  class="stroke"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.9999 2H2V13.8077H23.9999V2Z"
                    stroke="#132D48"
                    stroke-width="2.89286"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 18.9539H23.9999"
                    stroke="#132D48"
                    stroke-width="2.89286"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 24H23.9999"
                    stroke="#132D48"
                    stroke-width="2.89286"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </i>
            </button>
          </div>
        </li>
      </ul>
    </div>
    <!-- <b-button
          v-if="isSimulationContext && canCreateSimulation"
          :to="{ name: 'AddSimulation' }"
          pill
          size="sm"
          variant="outline-primary"
          class="px-3 my-2 mr-3 d-flex  text-nowrap add_simulation_btn"
          >  <span class="icon mr-2"></span>
          {{ $t("add_simulation") }}</b-button
        > -->
    <!-- <b-card
      class="border-raduis-xl border-0 box-shadow-sm"
      body-class="p-2 d-flex flex-column flex-sm-row align-items-center justify-content-between"
    >
      <div class="ml-0 ml-sm-3 mb-2 mb-sm-0 d-flex flex-auto align-items-center justify-content-center justify-content-md-start flex-wrap">
        <b-button
          v-if="isSimulationContext && canCreateSimulation"
          :to="{ name: 'AddSimulation' }"
          pill
          size="sm"
          variant="outline-primary"
          class="px-3 my-2 mr-3 d-flex  text-nowrap add_simulation_btn"
          >  <span class="icon mr-2"></span>
          {{ $t("add_simulation") }}</b-button
        >
        <b-button
          @click="$emit('download')"
          pill
          size="sm"
          variant="outline-primary"
           class="px-3 my-2 mr-3  text-nowrap"
          >

          <b-spinner variant="light" small class="mr-2 align-middle" v-if="downloadLoader"></b-spinner>
          <b-icon v-if="!downloadLoader" icon="download" class="mr-2"></b-icon>
          <span> {{ $t("download") }} </span>
        </b-button>
        <filter-modal
            :query-config="queryConfig"
            v-on:onFilter="onFilter($event)"
            v-on:onReloadData="reloadData($event)"
            :headerTitle="isSimulationContext ? 'filtrer_simulation' : 'filtrer_work'"
        ></filter-modal>
      </div>
      <div class="view-style d-flex flex-md-column flex-xl-row">
        <b-button
          @click="$emit('changeView', 'grid')"
          :class="[{ active: view === 'grid' }]"
          pill
          size="sm"
          variant="outline-primary"
          class="grid px-3 d-flex align-items-center"
          > <em class="icon icomoon2 icon2-cards mr-2"></em>
          {{ $t("details") }}</b-button
        >
        <b-button
          @click="$emit('changeView', 'list')"
          :class="[{ active: view === 'list' }]"
          pill
          size="sm"
          variant="outline-primary"
          class="list px-3 d-flex align-items-center"
          >  <em class="icon icomoon2 icon2-list mr-2"></em>
          {{ $t("list") }}</b-button
        >
      </div>
    </b-card> -->
  </div>
</template>

<script>
import FilterModal from "./FilterModal.vue";
import { mapGetters } from "vuex";
import { routeUtils } from "@/shared/route.util";
import { constants } from "@/shared/constants";

export default {
  name: "Actions",
  components: { FilterModal },
  props: [
    "view",
    "isSimulationContext",
    "queryConfig",
    "newUserModal",
    "teamQuery",
    "agenceQuery",
    "operationQuery",
    "disableview",
    "selectedTab"
  ],
  computed: {
    ...mapGetters("loader", {
      downloadLoader: "getDownloadWorksOrSimulations"
    }),
    ...mapGetters("account", ["getCurrentUser"]),
    isTeamAgenceRoute() {
      return (
        this.$route.path.includes("agences") &&
        this.$route.path.includes("users")
      );
    },
    isSimulation() {
      return this.selectedTab === constants.EntityType.SIMULATION;
    },
    isOuvrage() {
      return this.selectedTab === constants.EntityType.PROJECT;
    }
  },
  data() {
    return {
      canCreateSimulation: false,
      search: "",
      EntityType: constants.EntityType
    };
  },
  mounted() {
    this.canCreateSimulation = routeUtils.isAllowed(
      constants.CREATE_SIMULATION
    );
  },
  methods: {
    onFilter(filter) {
      this.$emit("applyFilter", {
        isSimulationFilter: this.isSimulationContext,
        filter: filter
      });
    },
    reloadData(filter) {
      this.$emit("reloadData", {
        isSimulationFilter: this.isSimulationContext,
        filter: filter
      });
    },
    usersFilter(filter) {
      this.$emit("onUsersFilter", {
        isTeamFilter: this.teamQuery,
        filter: filter
      });
    },
    AgencesFilter(filter) {
      this.$emit("onAgencesFilter", {
        isAgenceFilter: this.agenceQuery,
        filter: filter
      });
    },
    OperationsFilter(filter) {
      this.$emit("onOperationsFilter", {
        isOperationFilter: this.operationQuery,
        filter: filter
      });
    },
    newUser() {
      this.$emit("newUserModal");
    },
    newAgence() {
      this.$emit("newAgenceModal");
    },
    onSearch() {
      this.$emit("search", this.search);
    },
    onEntityTypeClick(type) {
      this.$emit("filterTab", type);
    }
  }
};
</script>
<style lang="scss">
.flex-auto {
  flex: auto;
}
</style>
